export enum EditFormKeys {
    Name = 'name',
    Description = 'description',
    Code = 'code',
    Products = 'products',
    Companies = 'companies',
}
